import { render, staticRenderFns } from "./Membership.vue?vue&type=template&id=13c2b028&scoped=true&"
import script from "./Membership.vue?vue&type=script&lang=js&"
export * from "./Membership.vue?vue&type=script&lang=js&"
import style0 from "./Membership.vue?vue&type=style&index=0&id=13c2b028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2b028",
  null
  
)

export default component.exports